import React from 'react'
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Checkbox,
  FormGroup,
  Typography,
} from '@mui/material'
import tw from 'twin.macro'
import { RiskMinor } from '@shopify/polaris-icons'

interface Props {
  name?: string
  label?: string
  value?: (string | number | boolean)[]
  error?: boolean
  helperText?: string | false
  options: Array<BasicRadioOption>
  onChange(e: React.ChangeEvent<any>): void
}

export interface BasicRadioOption {
  label: string
  value: string | number | boolean
}

export const BasicCheckboxSelect = ({
  name,
  label,
  value,
  error,
  helperText,
  options,
  onChange,
}: Props) => {
  const getColorStyle = (option: BasicRadioOption) => {
    if (error) {
      return {
        container: tw`border-critical-500`,
        text: tw`text-critical-500`,
      }
    }

    if (value?.includes(option.value)) {
      return {
        container: tw`border-primary-500`,
        text: tw`text-primary-500`,
      }
    }

    return {
      container: tw`border-shades-400`,
      text: tw`text-shades-400`,
    }
  }

  return (
    <FormControl css={tw`w-full`} error={error}>
      <FormLabel id={name}>{label}</FormLabel>
      <FormGroup aria-labelledby={name} onChange={onChange}>
        {options.map((option) => (
          <FormControlLabel
            key={option.value + option.label}
            value={option.value}
            css={[
              tw`w-full rounded-lg border border-solid mb-4 ml-0 p-0.5`,
              getColorStyle(option).container,
            ]}
            control={<Checkbox css={getColorStyle(option).text} />}
            label={
              <Typography css={[tw`w-full`, getColorStyle(option).text]}>{option.label}</Typography>
            }
          />
        ))}
      </FormGroup>
      {!!error && !!helperText && (
        <FormHelperText css={tw`ml-0`} component="div">
          <div css={tw`flex items-center gap-1`}>
            <RiskMinor width={20} css={tw`fill-critical-500`} />
            <Typography variant="body2" css={tw`text-critical-500`} component="span">
              {helperText}
            </Typography>
          </div>
        </FormHelperText>
      )}
    </FormControl>
  )
}
